import { render, staticRenderFns } from "./SideCenterShareSlides.vue?vue&type=template&id=88618364&scoped=true&"
import script from "./SideCenterShareSlides.vue?vue&type=script&lang=js&"
export * from "./SideCenterShareSlides.vue?vue&type=script&lang=js&"
import style0 from "./SideCenterShareSlides.vue?vue&type=style&index=0&id=88618364&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88618364",
  null
  
)

export default component.exports